export default `
  mutation CreateReportV2(
    $dateFrom: String,
    $dateTo: String,
    $lang: String,
    $country: [String],
    $auditor: [String],
    $state: [String],
    $currency: [String],
    $columns: [String],
    $title: String,
    $origin: String
  ) {
    createReportV2(
      dateFrom: $dateFrom,
      dateTo: $dateTo,
      lang: $lang,
      country: $country,
      auditor: $auditor,
      state: $state,
      currency: $currency,
      columns: $columns,
      title: $title,
      origin: $origin
    ) {
      id
      generating
      ready
      failed
      report_version
    }
  }
`;
